import { createReducer, on } from '@ngrx/store';
import * as TryItActions from '../actions/try-it.actions';
import * as AuthActions from '../actions/auth.actions';
import { TryItRequestsState } from '../models/try-it.model';
import { ApiDefTryItRequestData } from '@api/index';

export const initialTryItRequestsState: TryItRequestsState = {
  currentSelectedRequest: null,
  requests: [],
};

export const tryItRequestsReducer = createReducer(
  initialTryItRequestsState,
  
  on(TryItActions.tryItProxyRequestSuccess, (state, { response }) => {
    if (!response.id) return state;
    
    // Check if the request already exists to avoid duplicates
    const exists = state.requests.some(req => req.id === response.id);
    if (exists) return state;
    
    return {
      ...state,
      requests: [...state.requests, response],
      currentSelectedRequest: response.id,
    };
  }),
  
  on(TryItActions.tryItProxyRequestFailure, (state, { error }) => {
    const errorRequest = { errorType: error } as ApiDefTryItRequestData;
    return {
      ...state,
      requests: [...state.requests, errorRequest],
      currentSelectedRequest: null
    };
  }),
  
  on(TryItActions.resetTryItProxyRequest, (state) => ({
    ...state,
    requests: [],
    currentSelectedRequest: null,
    pathToRequestIds: {}
  })),
  
  on(TryItActions.setCurrentSelectedRequest, (state, { requestId }) => ({
    ...state,
    currentSelectedRequest: requestId
  })),
  
  on(TryItActions.loadRequestHistorySuccess, (state, { requests }) => {
    const existingRequestsMap = new Map(
      state.requests.map(req => [req.id, req])
    );
    const updatedRequests = [...state.requests];
    
    requests.forEach(newRequest => {
      if (!newRequest.id) return;
      if (!existingRequestsMap.has(newRequest.id)) {
        updatedRequests.push(newRequest);
      }
    });
    
    return {
      ...state,
      requests: updatedRequests,
    };
  }),
  
  on(AuthActions.logout, AuthActions.clearUserData, () => initialTryItRequestsState)
);
